import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorViewerComponent } from './error-viewer.component';
import { DssTypographyModule } from '@dss/components/typography';
import { DssAccordionModule } from '@dss/components/accordion';
import { DssDrawerModule } from '@dss/components/drawer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DssFormFieldModule } from '@dss/components/form-field';

@NgModule({
  declarations: [ErrorViewerComponent],
  imports: [
    CommonModule,
    DssTypographyModule,
    DssAccordionModule,
    DssDrawerModule,
    FormsModule,
    ReactiveFormsModule,
    DssFormFieldModule
  ],
  exports:[ErrorViewerComponent]
})
export class ErrorViewerModule { }
